import React, { useState, useEffect } from 'react';
import { Button, InputNumber, message } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import IconFont from '@/components/IconFont';
import intl from 'react-intl-universal';
import { isNil } from '@/utils/number';
import { storage } from '@/utils';
import styles from './index.module.scss';

const percentageList = [0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1.0, 1.1, 1.25, 1.5, 1.75, 2, 3, 4];

const Index = () => {
  const [index, setIndex] = useState<number>(7);
  const [isFullScreen, setIsFullScreen] = useState<boolean>(false);
  const [isInElectron, setIsInElectron] = useState(Boolean(window.electron));
  const win: any = window;

  const handleMinus = () => {
    if (index > 0) {
      setIndex(index - 1);
      storage.set('screenZoomIndex', index - 1);
      win.electron?.ipcRenderer.zoomChange(percentageList[index - 1]);
    }
  };

  const handlePlus = () => {
    if (index < percentageList.length - 1) {
      setIndex(index + 1);
      console.log('handlePlus', index + 1);
      storage.set('screenZoomIndex', index + 1);
      win.electron?.ipcRenderer.zoomChange(percentageList[index + 1]);
    }
  };

  const handleFullScreen = () => {
    storage.set('fullScreenFlag', !isFullScreen);
    if (isInElectron) {
      setIsFullScreen(!isFullScreen);
      win.electron?.ipcRenderer.screenResize(isFullScreen ? 'full-screen-Exit' : 'full-screen');
    } else {
      // 浏览器环境
      if (!document.fullscreenElement) {
        // 进入全屏
        document.documentElement.requestFullscreen().catch((err) => {
          console.log(`Error attempting to enable fullscreen: ${err.message}`);
        });
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen().catch((err) => {
            console.log(`Error attempting to exit fullscreen: ${err.message}`);
          });
        }
      }
    }
  };

  const resetZoom = () => {
    setIndex(7);
    storage.set('screenZoomIndex', 7);
    win.electron?.ipcRenderer.zoomChange(percentageList[7]);
  };

  useEffect(() => {
    const screenZoomIndex = storage.get('screenZoomIndex');
    const fullScreenFlag = JSON.parse(storage.get('fullScreenFlag'));
    setIndex(screenZoomIndex ? +screenZoomIndex : 7); // 初始化默认值
    setIsFullScreen(fullScreenFlag); // 初始化全屏状态
    setIsInElectron(Boolean(window.electron));

    const handleFullscreenChange = () => {
      const flag = !!document.fullscreenElement;
      setIsFullScreen(flag);
      storage.set('fullScreenFlag', flag);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  const number = (percentageList[index] * 100).toFixed(0);
  return (
    <div className={styles.systemScreenWrapper}>
      <p className={styles.pageSubTitle}>{intl.get('app_custom_quick_entry_screen')}</p>
      <div className={styles.actionWrapper}>
        {isInElectron && (
          <div className={styles.item}>
            <div className={styles.name}>{intl.get('app_custom_quick_entry_screen_zoom')}</div>
            <div className={styles.addAndReduce}>
              <Button
                icon={
                  <IconFont
                    type="icon-suoxiao"
                    style={{ color: '#666666', fontSize: '26px' }}
                    onClick={handleMinus}
                  />
                }
                className={styles.actionBtn}
              />
              <div className={styles.scaleValue}>{number}%</div>
              <Button
                className={styles.actionBtn}
                icon={
                  <IconFont
                    type="icon-fangda"
                    style={{ color: '#666666', fontSize: '26px' }}
                    onClick={handlePlus}
                  />
                }
              />
            </div>
            <Button type="primary" ghost className={styles.btn} onClick={resetZoom}>
              {intl.get('app_custom_quick_entry_screen_zoom_reset_default')}
            </Button>
          </div>
        )}

        <div className={styles.item}>
          <div className={styles.name}>{intl.get('app_custom_quick_entry_full_screen_tips')}</div>
          <Button type="primary" ghost className={styles.btn} onClick={handleFullScreen}>
            {isFullScreen
              ? intl.get('app_custom_quick_entry_screen_zoom_exit_fullscreen')
              : intl.get('app_custom_quick_entry_screen_zoom_enter_fullscreen')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Index;
